


















import Vue from 'vue';

export default Vue.extend({
  name: 'InputBoolean',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
});
